import dynamic from 'next/dynamic'

/** Loaded only when a layout renders the popup (code-split, no SSR). */
export const LazyInactiveLeadPopup = dynamic(
  () => import('../shared/InactiveLeadPopup'),
  {
    ssr: false,
    loading: () => null,
  }
)

export const LazyProspectQuizNudge = dynamic(
  () => import('../shared/ProspectQuizNudge'),
  {
    ssr: false,
    loading: () => null,
  }
)

export const LazyProspectQuiz = dynamic(
  () => import('../shared/ProspectQuiz'),
  {
    ssr: false,
    loading: () => null,
  }
)
